import {Link} from 'react-router-dom';
import React from 'react';


function CardItem(props) {
   return (
      <>
         <li className='cards__item'>
            <Link className='cards__item__link' to={props.url}>
               <figure className='cards__item__pic-wrap' data-category={props.label}>
                  <img src={props.src} text='Image' className='cards__item__img'></img>
               </figure>
               <div className='cards__item__info'>
                  <h5 className='cards__item__title'>{props.title}</h5>
                  <p className='cards__item__text'>{props.text}</p>
               </div>
            </Link>
         </li>
      </>
   )
}

export default CardItem;